/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosResponse } from "axios";
import { GetAllApproverListApiResponse } from "../../@types/DRO/GetAllApproverResponse";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class GetAllApproverListApi {
  public static api = new GetAllApproverListApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getAllApproverList(): Promise<GetAllApproverListApiResponse> {
    try {
      const response: AxiosResponse<GetAllApproverListApiResponse> =
        await this.instance.get("/erp/api/v1/purchase-order/approval/list", {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching predictions latest data", error);
      throw error;
    }
  }

  async approvePurchaseOrder(purchaseOrderId: number): Promise<void> {
    try {
      const body: { purchaseOrderId: number } = { purchaseOrderId };
      await this.instance.put(
        "/erp/api/v1/purchase-order/approval/approve",
        body,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      console.log("Purchase order approved successfully");
    } catch (error) {
      console.error("Error approving purchase order", error);
      throw error;
    }
  }
  async rejectPurchaseOrder(purchaseOrderId: number): Promise<void> {
    try {
      const body: { purchaseOrderId: number } = { purchaseOrderId };
      await this.instance.put(
        "/erp/api/v1/purchase-order/approval/reject",
        body,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      console.log("Purchase order approved successfully");
    } catch (error) {
      console.error("Error approving purchase order", error);
      throw error;
    }
  }
  async sendBackToApproval(purchaseOrderId: number): Promise<void> {
    try {
      const body: { purchaseOrderId: number } = { purchaseOrderId };
      await this.instance.put(
        "/erp/api/v1/purchase-order/approval/send-back",
        body,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      console.log("Purchase order approved successfully");
    } catch (error) {
      console.error("Error approving purchase order", error);
      throw error;
    }
  }
}
